import { PageHeader } from '../components/sections/PageHeader';
import { ServicesExplorer } from '../components/sections/ServicesExplorer';
import { BeforeAfter } from '../components/sections/BeforeAfter';
import { ToolMarquee } from '../components/sections/ToolMarquee';
import { ContactCTA } from '../components/sections/ContactCTA';
import { COLLABORATION, TECH_STACK } from '../data/siteData';
import { Reveal } from '../hooks/useMotion';

export const ServicesPage = () => (
  <div data-testid="services-page">
    <PageHeader eyebrow="Our services" title="End-to-end BIM support">
      From design coordination to construction documentation, delivered by engineers who know what has to be
      built on site.
    </PageHeader>

    <section className="sec white">
      <div className="wrap">
        <Reveal className="hd">
          <div className="mono">What we deliver</div>
          <h2>Model · Coordinate · Document · Support</h2>
          <p>Choose a service to see its deliverables and the tools we use.</p>
        </Reveal>
        <ServicesExplorer />
      </div>
    </section>

    <section className="sec">
      <div className="wrap">
        <BeforeAfter />
      </div>
    </section>

    <ToolMarquee />

    <section className="sec white">
      <div className="wrap">
        <Reveal className="hd">
          <div className="mono">Technology stack</div>
          <h2>Accurate modeling, coordinated workflows, traceable data</h2>
        </Reveal>
        <div className="cards3">
          {TECH_STACK.map((t, i) => (
            <Reveal key={t.title} className="card" delay={i * 80}>
              <div className="k">{String(i + 1).padStart(2, '0')}</div>
              <h3>{t.title}</h3>
              <div className="chips">{t.tools.map((tool) => <span key={tool}>{tool}</span>)}</div>
              <div className="benefits">{t.benefits.map((b) => <span key={b}>{b}</span>)}</div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>

    <section className="sec">
      <div className="wrap">
        <Reveal className="hd">
          <div className="mono">Digital collaboration</div>
          <h2>Connected data for faster, more reliable decisions</h2>
        </Reveal>
        <div className="cards3">
          {COLLABORATION.map((c, i) => (
            <Reveal key={c.title} className="card" delay={i * 80}>
              <h3>{c.title}</h3>
              <p>{c.text}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>

    <ContactCTA />
  </div>
);

export default ServicesPage;
